import { c as _c } from "react/compiler-runtime";
import { ComponentType } from "react";
import { useFormContext } from "react-hook-form";
import { InputError, InputLabel, RadioGroup } from "@/components/global/form/inputs/";
import { InputErrorStyleProps, InputLabelStyleProps, InputWrapperStyleProps, RadioInputStyleProps } from "@/components/global/form/inputs/styles";
import { FormFieldLayout } from "../layouts/form-field-layout";
interface FormRadioGroupProps {
  name: string;
  hidden?: boolean;
  label: string;
  options: Array<{
    value: string;
    label: string;
    dataCy?: string;
  }>;
  required?: boolean;
  error?: string;
  isValid?: boolean;
  disabled?: boolean;
  defaultValue?: string;
  component?: ComponentType<any>;
  styles?: {
    wrapper?: InputWrapperStyleProps;
    error?: InputErrorStyleProps;
    label?: InputLabelStyleProps;
    input?: RadioInputStyleProps;
    formFieldLayout?: {
      className?: string;
    };
    radioFieldLayout?: {
      className?: string;
    };
  };
}
export const FormRadioGroup = t0 => {
  const $ = _c(28);
  const {
    name,
    label,
    options,
    required,
    error,
    isValid,
    disabled,
    styles,
    defaultValue,
    hidden,
    component: t1
  } = t0;
  const InputComponent = t1 === undefined ? RadioGroup : t1;
  const {
    register
  } = useFormContext();
  const t2 = styles?.formFieldLayout?.className;
  const t3 = styles?.label;
  let t4;
  if ($[0] !== label || $[1] !== name || $[2] !== required || $[3] !== t3) {
    t4 = <InputLabel htmlFor={name} label={label} required={required} styles={t3} />;
    $[0] = label;
    $[1] = name;
    $[2] = required;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== name || $[6] !== register) {
    t5 = register(name);
    $[5] = name;
    $[6] = register;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = styles?.wrapper;
  const t7 = styles?.input;
  const t8 = styles?.radioFieldLayout;
  const t9 = defaultValue ? defaultValue : undefined;
  let t10;
  if ($[8] !== InputComponent || $[9] !== disabled || $[10] !== error || $[11] !== hidden || $[12] !== isValid || $[13] !== options || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <InputComponent {...t5} options={options} error={error} isValid={isValid} disabled={disabled} wrapperStyles={t6} styles={t7} radioFieldLayout={t8} defaultValue={t9} hidden={hidden} />;
    $[8] = InputComponent;
    $[9] = disabled;
    $[10] = error;
    $[11] = hidden;
    $[12] = isValid;
    $[13] = options;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== error || $[21] !== styles?.error) {
    t11 = error && <InputError error={error} styles={styles?.error} />;
    $[20] = error;
    $[21] = styles?.error;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t2 || $[26] !== t4) {
    t12 = <FormFieldLayout className={t2}>{t4}{t10}{t11}</FormFieldLayout>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t2;
    $[26] = t4;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
FormRadioGroup.displayName = "FormRadioGroup";